import React, { Component } from 'react';
import ContentWrapper from '../components/ContentWrapper';
import PageTitle from '../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

// import MarketplaceIcon from '@atlaskit/icon/glyph/marketplace';
import DepartmentIcon from '@atlaskit/icon/glyph/department';
import ScreenIcon from '@atlaskit/icon/glyph/screen';
import LocationIcon from '@atlaskit/icon/glyph/location';
import MediaServicesBlurIcon from '@atlaskit/icon/glyph/media-services/blur';
import CalendarFilledIcon from '@atlaskit/icon/glyph/calendar-filled';
import EditorInfoIcon from '@atlaskit/icon/glyph/editor/info';
import DocumentsIcon from '@atlaskit/icon/glyph/documents';

import './HomePage.css';

class HomePage extends Component {

  render() {
    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Dashboard</PageTitle>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title"><LocationIcon size="large" /> Points of Interests</h2>
                    {/* <h2 className="card-title"><MarketplaceIcon size="large" /> Stores</h2> */}
                    <p className="card-text">{this.props.stores.length} Point of Interest{this.props.stores.length > 1 ? `s` : ``}</p>
                    <Link to='/pointofinterests'><button className="btn btn-primary" style={{marginRight: '10px'}}>Go To Point of Interests</button></Link>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title"><DepartmentIcon size="large" /> Categories</h2>
                    <p className="card-text">{this.props.categories.length} Categor{this.props.categories.length > 1 ? `ies` : `y`}</p>
                    <Link to='/categories'><button className="btn btn-primary" style={{marginRight: '10px'}}>Go To Categories</button></Link>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title"><ScreenIcon size="large" /> Kiosks</h2>
                    <p className="card-text">{this.props.kiosks.length} Kiosk{this.props.kiosks.length > 1 ? `s` : ``}</p>
                    <Link to='/kiosks'><button className="btn btn-primary" style={{marginRight: '10px'}}>Go To Kiosks</button></Link>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title"><EditorInfoIcon size="large" /> Amenities</h2>
                    <p className="card-text">{this.props.amenities.length} Amenit{this.props.amenities.length > 1 ? `ies` : `y`}</p>
                    <Link to='/amenities'><button className="btn btn-primary" style={{marginRight: '10px'}}>Go To Amenities</button></Link>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title"><MediaServicesBlurIcon size="large" /> Floorplans</h2>
                    <p className="card-text">{this.props.floorplans.length} Floorplan{this.props.floorplans.length > 1 ? `s` : ``}</p>
                    <Link to='/floorplans'><button className="btn btn-primary" style={{marginRight: '10px'}}>Go To Floorplans</button></Link>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title"><DocumentsIcon size="large" /> Medias</h2>
                    <p className="card-text">{this.props.medias.length} Media{this.props.medias.length > 1 ? `s` : ``}</p>
                    <Link to='/medias'><button className="btn btn-primary" style={{marginRight: '10px'}}>Go To Media Manager</button></Link>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <h2 className="card-title"><CalendarFilledIcon size="large" /> Events</h2>
                    <p className="card-text">{this.props.events.length} Event{this.props.events.length > 1 ? `s` : ``}</p>
                    <Link to='/events'><button className="btn btn-primary" style={{marginRight: '10px'}}>Go To Events</button></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    );
  }
}


const mapStateToProps = state => ({
  stores: state.stores.stores,
  categories: state.categories.categories,
  kiosks: state.kiosks.kiosks,
  amenities: state.amenities.amenities,
  floorplans: state.floorplans.floorplans,
  medias: state.medias.medias,
  events: state.events.events,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);


// WEBPACK FOOTER //
// ./src/pages/HomePage.js